var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M8 0C3.58886 0 0 3.58886 0 8C0 12.4111 3.58886 16 8 16C12.4111 16 16 12.4111 16 8C16 3.58886 12.4111 0 8 0ZM8.52038 12.7466C8.1403 12.81 7.38403 12.9682 6.99999 13C6.67492 13.0269 6.36815 12.8408 6.18115 12.5737C5.99367 12.3066 5.94874 11.9648 6.06005 11.6582L7.57225 7.50001H5.99998C5.99864 6.63356 6.64855 5.99647 7.47978 5.75197C7.87645 5.63526 8.61551 5.47555 8.99998 5.50003C9.23032 5.51468 9.63181 5.65919 9.81881 5.92631C10.0063 6.19339 10.0512 6.53519 9.93992 6.84183L8.42772 11H9.9995C9.9998 11.8655 9.37413 12.6043 8.52038 12.7466ZM8.99998 5.00001C8.44768 5.00001 7.99997 4.55224 7.99997 4C7.99997 3.4477 8.44768 2.99999 8.99998 2.99999C9.55228 2.99999 9.99998 3.4477 9.99998 4C9.99998 4.55227 9.55231 5.00001 8.99998 5.00001Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.98d63f1d.svg";
export { ForwardRef as ReactComponent };